module.exports = __webpack_public_path__ + "frontend/images/gold/seeWorld.png?f3f1dd1fdbfbafe9f07096ff2851333c";